export const temperaturaMask = (value: string) => {
  // Converte vírgula em ponto e remove espaços
  let v = value.replace(",", ".").replace(/\s+/g, "");

  // Permite opcionalmente um "-" no início, dígitos, e no máximo um ponto
  v = v.replace(/[^0-9\.-]/g, "");

  // Garante que "-" só apareça no início
  if (v.indexOf("-") > 0) v = v.replace(/-/g, "");
  if (v.slice(1).includes("-")) v = v.replace(/-/g, "");

  // Garante no máximo um ponto decimal
  const [intPart, ...rest] = v.split(".");
  if (rest.length > 0) v = intPart + "." + rest.join("").replace(/\./g, "");

  return v;
};
